class GlobalCartManager {
  constructor() {
    // ==========================================
    // ⚙️ CONFIGURATION: Update these selectors to match your theme
    // ==========================================
    this.selectors = {
      cartDrawer: '#CartDrawer',           // The ID of your main cart drawer container
      cartCount: '.cart-count-badge',      // The class for your global cart counter
      removeButton: '.js-remove-item',     // The class for your 'Remove' buttons in the cart
      addToCartForm: 'form[action^="/cart/add"]', // Selects all Add to Cart forms
    };
    
    // The filename of your cart drawer section (e.g., 'cart-drawer.liquid' -> 'cart-drawer')
    this.cartSectionId = 'cart-drawer'; 

    this.routes = {
      cartAdd: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js',
      cartChange: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js',
      cartJson: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js'
    };

    this.init();
  }

  init() {
    // 1. Listen for "Add to Cart" submissions anywhere on the site
    document.addEventListener('submit', (e) => {
      if (e.target.matches(this.selectors.addToCartForm)) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });

    // 2. Listen for clicks on "Remove" buttons inside the cart drawer
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest(this.selectors.removeButton);
      if (removeBtn) {
        e.preventDefault();
        const lineItemKey = removeBtn.dataset.key; // Make sure your remove button has data-key="{{ item.key }}"
        this.updateCartItem(lineItemKey, 0);
      }
    });
  }

  // --- AJAX Add to Cart ---
  async addToCart(form) {
    const formData = new FormData(form);
    
    // Optional: Add loading state to button here
    const submitBtn = form.querySelector('[type="submit"]');
    if(submitBtn) submitBtn.setAttribute('disabled', 'disabled');

    try {
      await fetch(this.routes.cartAdd, {
        method: 'POST',
        body: formData
      });
      
      await this.refreshCartState();
      this.openCartDrawer();
      
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      if(submitBtn) submitBtn.removeAttribute('disabled');
    }
  }

  // --- AJAX Update/Remove Item ---
  async updateCartItem(key, quantity) {
    try {
      await fetch(this.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      
      await this.refreshCartState();
      
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // --- Refresh the Drawer & Counter ---
  async refreshCartState() {
    try {
      // 1. Fetch the newly rendered HTML for the cart drawer using the Section API
      const response = await fetch(`/?section_id=${this.cartSectionId}`);
      const text = await response.text();

      // Parse the new HTML
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newDrawerContent = html.querySelector(this.selectors.cartDrawer);
      const currentDrawer = document.querySelector(this.selectors.cartDrawer);

      // Replace the old cart HTML with the new cart HTML
      if (newDrawerContent && currentDrawer) {
        currentDrawer.innerHTML = newDrawerContent.innerHTML;
      }

      // 2. Fetch cart JSON to update the global counter badge
      const cartRes = await fetch(this.routes.cartJson);
      const cart = await cartRes.json();
      
      const counters = document.querySelectorAll(this.selectors.cartCount);
      counters.forEach(counter => {
        counter.textContent = cart.item_count;
        // Optional: hide counter if 0, show if > 0
        counter.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
      });

    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }

  // --- Open the Cart Drawer ---
  openCartDrawer() {
    const drawer = document.querySelector(this.selectors.cartDrawer);
    if (drawer) {
      // Change 'is-open' to whatever class your theme uses to show the drawer
      drawer.classList.add('is-open'); 
      
      // Optional: lock body scroll
      document.body.classList.add('overflow-hidden');
    }
  }
}

// Initialize the script globally once the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.ShopifyCart = new GlobalCartManager();
});